// extracted by mini-css-extract-plugin
export default {"asideTabWrapper":"aside-tab-wrapper_asideTabWrapper__JuKlO","tab":"aside-tab-wrapper_tab__fhTE4"};